import { WorkflowConfig } from '@/app/workflows/actions/interfaces';

export const getTextureResolution = (config: WorkflowConfig) => {
  const values = Object.values(config.limits?.textures ?? {});
  const areAllValuesEqual = values.every((value) => value === values[0]);

  if (areAllValuesEqual) {
    return values[0] + '';
  }

  return values.join(',');
};
